import colors from 'config/config/colors';
import fonts from 'config/config/fonts';
import fontSizes from 'config/config/fontSizes';

import { isMobile } from 'react-device-detect';

const inputs = {
	maxWidth: { default: isMobile ? 'none' : '300px' },
	color: colors.black,
	fontFamily: fonts.regular,
	fontSize: fontSizes.md,
	padding: {
		default: '12px',
		date: '3px 12px',
		select: '3px 12px',
		currency: '0px',
	},
	border: {
		default: `1px solid ${colors.grey}`,
		filled: `1px solid ${colors.grey}`,
		radius: '3px',
	},
	placeholder: {
		color: colors.grey,
		fontFamily: fonts.light,
		fontSize: fontSizes.sm,
	},
	focus: {
		borderBottom: { full: `5px solid ${colors.primary}`, color: colors.primary },
	},
	selectOptions: {
		color: colors.grey,
		fontFamily: fonts.regular,
		fontSize: fontSizes.md,
	},
};

export default inputs;
